import React, { useContext, useEffect, useMemo } from 'react'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import analytics from '../../config/analytics'
import { EasybakeContext } from '../EasybakeProvider'
import Heading from '@react/react-spectrum/Heading'
import Link from '../Nav/Link'
import {Form} from '@react/react-spectrum/Form'
import Textfield from '@react/react-spectrum/Textfield'
import Textarea from '@react/react-spectrum/Textarea'
import Select from '@react/react-spectrum/Select'
import Checkbox from '@react/react-spectrum/Checkbox'
import Button from '@react/react-spectrum/Button'
import FieldLabel from '@react/react-spectrum/FieldLabel/js/FieldLabel'
import { isStringValid, isFormEmailValid, setBodyHeight, logAlert } from '../../lib/easybake'
import {
    getOrgs
} from '../../lib/consoleApi'
import { MAX_STRING_LENGTH, MAX_STRING_LENGTH_LONG } from '../../lib/constants'

export default function SingupForm () {
    const {
        dispatch,
        formCompanySize,
        formFullName,
        formEmail,
        formCompany,
        formRole,
        formUseCase,
        formAgreement,
        dMode,
        ut,
        page
    } = useContext(EasybakeContext)

    useEffect(() => {
        if (ut) {
            getUserOrgs()
            dispatch({ type: 'set-formAgreement', payload: { formAgreement: false } })
            setBodyHeight('adobe-easybake-main-sub-pane')
            setProfile()
        }
    }, [ut])

    async function getUserOrgs() {
        try {
            const orgs = await getOrgs(ut)
            if (orgs && orgs.error) {
                throw new Error(orgs.error)
            } else {
                dispatch({ type: 'set-userOrgs', payload: { userOrgs: orgs.response } })
            }
        } catch(e) {
            logAlert(e)
            analytics.sendEventName('click', `${page}:getuserorgs:error`)
        }
    }

    async function setProfile() {
        if (!formFullName || !formEmail) {
            if (window.easybake) {
                const profile = await window.easybake.parent.getIMSProfile()
                dispatch({ type: 'set-formFullName', payload: { formFullName: profile.name } })
                dispatch({ type: 'set-formEmail', payload: { formEmail: profile.email } })
            }
        }
    }

    function isDisabled() {
        // return false //TODO
        if (dMode) {
            return false
        }
        if (!formFullName || !formEmail || !formCompany || !formRole || !formUseCase || !formAgreement || (formCompanySize.filter( size => size.selected ).length === 0)) {
            return true
        }
        return false
    }

    function changeCompanySizeSelection (e) {
        const newOptions = formCompanySize.map( option => {
            if (option.value === e) {
                option.selected = true
            } else {
                option.selected = false
            }
            return option
        })
        dispatch({ type: 'set-formCompanySize', payload: { formCompanySize: newOptions } })
    }

    function getCompanySizeSelectionValue (e) {
        const selectValue = formCompanySize.find( option => option.selected === true)
        return selectValue && selectValue.value || null
    }

    function getAccessNow() {
        analytics.sendEventName('click', `${page}:getaccessnow`)
        dispatch({ type: 'set-page', payload: { page: 'create' } })
    }

    function cancel() {
        analytics.sendEventName('click', `${page}:cancel`)
        dispatch({ type: 'set-page', payload: { page: 'signup' } })
    }

    return <div className="adobe-easybake-main-sub-pane">
        

        <div className="adobe-easybake-main-sub-pane-header">
            <Heading variant="pageTitle" className="adobe-easybake-console-title">{__('signup_form_title')}</Heading>
            <br />
            <p>{__('signup_form_desc')}</p>
            <br />
        </div>

        <div className="adobe-easybake-main-contents">
            <div className="adobe-easybake-main-contents">
                <div className="adobe-easybake-box-parent">
                    <Form autoComplete="off">
                    <FieldLabel necessity="required" label={__('signup_form_filed_label_name')} labelFor="tf-fullname">
                        <Textfield 
                            disabled
                            // validationState={isStringValid(formFullName) ? 'valid' : 'invalid'}
                            placeholder={__('signup_form_filed_label_name')} 
                            id="tf-fullname" 
                            label="fullname"
                            maxLength={MAX_STRING_LENGTH}
                            defaultValue={formFullName}
                            onChange={ e => dispatch({ type: 'set-formFullName', payload: { formFullName: e } }) }
                            onBlur={ e => dispatch({ type: 'set-formFullName', payload: { formFullName: e.target.value } }) } />
                    </FieldLabel>
                    <br />
                    <FieldLabel necessity="required" label={__('signup_form_filed_label_email')} labelFor="tf-email">
                        <Textfield 
                            disabled
                            // validationState={isFormEmailValid(formEmail) ? 'valid' : 'invalid'}
                            placeholder={__('signup_form_filed_label_email')} 
                            id="tf-email" 
                            label="email"
                            maxLength={MAX_STRING_LENGTH}
                            defaultValue={formEmail}
                            onChange={ e => dispatch({ type: 'set-formEmail', payload: { formEmail: e } }) }
                            onBlur={ e => dispatch({ type: 'set-formEmail', payload: { formEmail: e.target.value } }) } />
                    </FieldLabel>
                    <br />
                    <FieldLabel necessity="required" label={__('signup_form_filed_label_company')} labelFor="tf-company">
                        <Textfield
                            // validationState={isStringValid(formCompany) ? 'valid' : 'invalid'}
                            placeholder={__('signup_form_filed_label_company_desc')} 
                            id="tf-company" 
                            label="company"
                            maxLength={MAX_STRING_LENGTH}
                            defaultValue={formCompany}
                            onChange={ e => dispatch({ type: 'set-formCompany', payload: { formCompany: e } }) }
                            onBlur={ e => dispatch({ type: 'set-formCompany', payload: { formCompany: e.target.value } }) } />
                    </FieldLabel>
                    <br />
                    <FieldLabel necessity="required" label={__('signup_form_filed_label_role')} labelFor="tf-role">
                        <Textfield
                            // validationState={isStringValid(formRole) ? 'valid' : 'invalid'}
                            placeholder={__('signup_form_filed_label_role_desc')} 
                            id="tf-role" 
                            label="role"
                            maxLength={MAX_STRING_LENGTH}
                            defaultValue={formRole}
                            onChange={ e => dispatch({ type: 'set-formRole', payload: { formRole: e } }) }
                            onBlur={ e => dispatch({ type: 'set-formRole', payload: { formRole: e.target.value } }) } />
                    </FieldLabel>
                    <br />
                    <FieldLabel necessity="required" label="Company Size" labelFor="tf-formCompanySize">
                        <Select
                            // validationState={(formCompanySize.filter( size => size.selected ).length !== 0) ? 'valid' : 'invalid'}
                            aria-label="tf-formCompanySize"
                            required
                            label="companysize"
                            defaultValue={getCompanySizeSelectionValue()}
                            placeholder={__('signup_form_filed_label_company_size_desc')}
                            onChange={ e => changeCompanySizeSelection(e) }
                            options={ formCompanySize } />
                    </FieldLabel>
                    <br />
                    <FieldLabel necessity="required" label={__('signup_form_filed_label_use_case')} labelFor="tf-usecase">
                        <Textarea 
                            // validationState={isStringValid(formUseCase) ? 'valid' : 'invalid'}
                            name="tf-usecase" 
                            defaultValue={formUseCase}
                            label="usecase"
                            maxLength={MAX_STRING_LENGTH_LONG}
                            onChange={ e => dispatch({ type: 'set-formUseCase', payload: { formUseCase: e } }) }
                            onBlur={ e => dispatch({ type: 'set-formUseCase', payload: { formUseCase: e.target.value } }) }/>
                    </FieldLabel>
                    <br />
                    <div className="adobe-easybake-form-left">
                        <FieldLabel necessity="required" label={__('signup_form_filed_label_prerelease')} labelFor="tf-agreement">
                        <div className="adobe-easybake-form-check-multi">
                            <Checkbox
                                // validationState={formAgreement ? 'valid' : 'invalid'}
                                onChange={ e => dispatch({ type: 'set-formAgreement', payload: { formAgreement: e } }) }
                                defaultValue={formAgreement}
                                renderLabel={false}
                                name="tf-agreement" />
                                <div className="adobe-easybake-form-check-multi-lines">
                                    {__('signup_form_filed_label_prerelease_desk')}
                                    <span className="adobe-easybake-span-space-right"/>
                                    <Link className="adobe-easybake-nav-link" referrer={`console:${page}:prereleaseterms`} label={__('signup_form_filed_label_prerelease_desk_link')} url={__('url_signup_form_filed_label_prerelease')} noBreak={true} />
                                    <span className="adobe-easybake-space-left-right">and</span>
                                    <Link className="adobe-easybake-nav-link" referrer={`console:${page}:privatepolicy`} label={__('signup_form_filed_label_prerelease_desk_link_pp')} url={__('url_signup_form_filed_label_PrivacyPolicy')} noBreak={true} />
                                </div>
                        </div>
                        </FieldLabel>
                    </div>
                    <hr className="adobe-easybake-hr"/>
                    <div className="adobe-easybake-well-card-button">
                        <Button quiet variant="primary" onClick={ e => cancel(e) }>{__('signup_form_filed_btn_cancel')}</Button>
                        <Button variant="cta" onClick={ e => getAccessNow(e) } disabled={ isDisabled() }>{__('signup_form_filed_btn_ok')}</Button>
                    </div>
                    <br />
                    <p className="adobe-easybake-p">{__('signup_form_filed_label_prerelease_term')}
                        <Link className="adobe-easybake-nav-link" referrer={`console:${page}:learnmore`} label={__('signup_form_filed_label_prerelease_learn')} url={__('url_signup_form_filed_label_learn')} noBreak={true} />
                    </p>
                    </Form>
                </div>
                <br />
                <br />
                <br />
            </div>
            <br />
            <br />
            <br />
            <br />
        </div>
    </div>
}
